// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});



// export function collapsebutton_viewportEnter() {
// 		$w("#logoStrip").expand();
// }
// export function collapsebutton_viewportLeave() {
// 	$w("#logoStrip").collapse();
// }


export function box2_viewportLeave(event) {
	$w("#logoStrip").collapse();
}

export function box2_viewportEnter(event) {
	$w("#logoStrip").expand();
}

